// Only the browser renews Heimdall's 5-minute cache cookie, and by default it refetches only on
// load, focus and reconnect.
export const heimdallSessionOptions = { refetchInterval: 60 };
